/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type SensorsHealthStatus = (typeof SensorsHealthStatus)[keyof typeof SensorsHealthStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SensorsHealthStatus = {
  HealthStatusLive: 'live',
  HealthStatusStale: 'stale',
  HealthStatusMissing: 'missing',
  HealthStatusUnknown: 'unknown',
} as const;
